import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import CurrencyCodes from "currency-codes";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";

import styles from "../styles/add.module.css";
// import { createPromo, listCountries, specificPromo, updatePromo } from "../api";
// import PromoSchema from "../validations/promos";
import { APP_ROUTES } from "../../../lib/constants";
import { CONSTANTS } from "../../../lib/constants/messages";
import { Layout } from "../../../ui";
// import { addSubadmin, getSubadmin, partnerWebsitesList, updateRole } from "../api";
import { title } from "process";
import { ManualOrderSchema } from "../validation";
import { update } from "../../users/api";
import { getRoles } from "../../roles/api";
import { addUser, getUser, updateUser } from "../api";
import { getRole } from "../../../lib/common/common";

const AddNewUser = () => {
    const navigate = useNavigate();
    const params = useParams();

    const [partners, setPartners] = useState<{ value: string, label: string }[]>([
        { value: "1", label: "ALL" },
        { value: "2", label: "ACCOUNTANT" },
        { value: "3", label: "LOGISTICS" },
        { value: "4", label: "DISPATCH" },
        { value: "5", label: "DOT" }
      ]);
    const [roles, setRoles] = useState<{ value: string, label: string }[]>([]);
    const selectInputRef = useRef<any>();
    const [isDisabled, setIsDisabled] = useState<boolean>(false);

    const onClear = () => {
        if (selectInputRef.current) {
            selectInputRef.current.clearValue();
        }
    };

    const addEditPromoFormik = useFormik({
        initialValues: {
         
            name: "",
            phoneNumber:"",
            partnerWebsiteId: {label:"Select Role", value:""},
            email:"",
            password:"",
            // permissionId: {label:"Select Role", value:""},
             
        },
        validationSchema: ManualOrderSchema,
        onSubmit: (values, { setSubmitting }) => {
            console.log(values, "values")
          
        const payload:any = {
          
                email: values.email,
                fullName: values.name,
                role: Number(values.partnerWebsiteId.value),
                phoneNumber: values.phoneNumber.toString(),
                
                
                // permissionId: values.permissionId.value,
               
              
        }
        if(values.password){
            payload['password'] = values.password;}
            

           { !params.id?addUser(payload).then((res) => {
                toast.success("Subadmin added successfully")
                navigate(APP_ROUTES.USERS);
            }):updateUser(params.id as string, payload).then((res) => {
                toast.success("Subadmin updated successfully")
                navigate(APP_ROUTES.USERS);
            })}
            // if (values.countries.length) {

            // if(values.discountCurrency.length) {
            //     payload['discountCurrency'] = values.discountCurrency;
            // }

            // if (params.id) {
            //     payload["promoId"] = params.id;
            // }

            // toast.promise(
            //     params.id ? updatePromo(payload, params.id as string) : createPromo(payload),
            //     {
            //         pending: {
            //             render() {
            //                 return params.id ? CONSTANTS.PROMO.UPDATING : CONSTANTS.PROMO.CREATING;
            //             },
            //         },
            //         success: {
            //             render() {
            //                 setSubmitting(false);

            //                 addEditPromoFormik.resetForm();
            //                 onClear();
            //                 navigate(APP_ROUTES.PROMOS);

            //                 return params.id ? CONSTANTS.PROMO.UPDATE_SUCCESS : CONSTANTS.PROMO.CREATE_SUCCESS;
            //             },
            //         },
            //         error: {
            //             render({ data }: any) {
            //                 setSubmitting(false);

            //                 return params.id ? data.data.message : CONSTANTS.PROMO.CREATE_FAILED;
            //             },
            //         },
            //     });
        },
    });
    const permissionsList = ["ICCID", "Customers", "APIs", "Users"];
    const permissionsList2 = [
        "users",
        "cms",
        "plans",
        "geofence",
        "orders",
        "promos",
        "coupons",
        "blogs",
        "notifications",
        "reportAndAnalytics",
        "commbitzEventsUser",
        // "partners",
        "sandbox",
        "secretKeyConfigurations",
       
      ];
const actions = ["view", "edit", "delete"];


  const [permissions, setPermissions] = useState(
    permissionsList.reduce((acc:any, perm) => {
      acc[perm] = {
        view: false,
        edit: false,
        delete: false,
      };
      return acc;
    }, {})
  );
  
  const [permissions2, setPermissions2] = useState(
    permissionsList2.reduce((acc:any, perm) => {
      acc[perm] = {
        view: false,
        edit: false,
        delete: false,
      };
      return acc;
    }, {})
  );

  const handleChange = (perm:any, action:any) => {
    setPermissions((prev:any) => ({
      ...prev,
      [perm]: {
        ...prev[perm],
        [action]: !prev[perm][action],
      },
    }));
  };
  const handleChange2 = (perm:any, action:any) => {
    setPermissions2((prev:any) => ({
      ...prev,
      [perm]: {
        ...prev[perm],
        [action]: !prev[perm][action],
      },
    }));
  };

    // useEffect(() => {
    //     partnerWebsitesList().then(({ data }) => {
    //         const partners = data.map((item:any) => ({ label: item.partnerName, value: item._id }))
    //         setPartners(partners);
    //         console.log(partners, "partners")
    //     });
    // }, []);


    useEffect(() => {
        if (params.id) {
            console.log(params.id, "params id")
            getUser(params.id as string).then(res => {
                const {fullName,email,role,phoneNumber} = res.data;
               

                // if (moment(promo.startDate).isBefore(moment()) && moment(promo.endDate).isAfter(moment())) {
                //     setIsDisabled(true);
                //     toast.error("You cannot edit this promo since it has already started");
                // }
                // else if (moment(promo.endDate).isBefore(moment())) {
                //     setIsDisabled(true);
                //     toast.error("You cannot edit this promo since it has already ended");
                // }

                // const countries: any = promo.countries.map(item => ({ value: item._id, label: item.name }));

                addEditPromoFormik.setFieldValue("name", fullName);
                addEditPromoFormik.setFieldValue("email", email);
                console.log(role, "role")
                console.log({ label:getRole(role) , value: role.toString() })
                addEditPromoFormik.setFieldValue("partnerWebsiteId", { label:getRole(role) , value: role.toString() });
                addEditPromoFormik.setFieldValue("phoneNumber", phoneNumber);
            });
        }
    }, [params.id]);

    
    const customStyles  = {
        control: (provided: any) => ({
          ...provided,
          backgroundColor: 'transparent',
          color: 'white',
          borderColor: 'white',
        }),
        singleValue: (provided: any) => ({
          ...provided,
          color: 'white',
        }),
        menu: (provided: any) => ({
          ...provided,
          backgroundColor: 'black', // Optional: for contrast
        }),
        option: (provided: any, state: any) => ({
          ...provided,
          color: 'white',
          backgroundColor: state.isFocused ? 'gray' : 'black', // Optional hover/focus styling
        }),
        input: (provided: any) => ({
          ...provided,
          color: 'white',
        }),
      };
    

    return (
        <Layout title="User">
            <div className={styles.addCoupon}>
                <h4>{params.id ? "Edit" : "Add new"} User</h4>
                <form className="mt-3">
                    <div className="row">
                        {/* <div className="col-md-12">
                            <div className={styles.fromGroup}>
                                <label>Add Image</label>
                                <div className={styles.fileTypee}>
                                    <input type="file" placeholder="" />
                                    <div className={styles.fileBtns}>
                                        <Image width={100} height={100} src="/assets/images/fileType.png" alt="userImage" />
                                        <span>Choose File  <Image width={100} height={100} src="/assets/images/phtoo.png" alt="userImage" /></span>
                                        <p>No File Choosen </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Name
                                    {
                                        addEditPromoFormik.touched.name && addEditPromoFormik.errors.name ?
                                            <span className="error">{addEditPromoFormik.errors.name}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="text"
                                    placeholder="Name"
                                    name="name"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    disabled={isDisabled}
                                    value={addEditPromoFormik.values.name}
                                />
                            </div>
                            
                        </div>
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Phone Number
                                    {
                                        addEditPromoFormik.touched.phoneNumber && addEditPromoFormik.errors.phoneNumber ?
                                            <span className="error">{addEditPromoFormik.errors.phoneNumber}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="number"
                                    placeholder="Phone Number"
                                    name="phoneNumber"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    disabled={isDisabled}
                                    value={addEditPromoFormik.values.phoneNumber}
                                />
                            </div>
                            
                        </div>
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Email
                                    {
                                        addEditPromoFormik.touched.email && addEditPromoFormik.errors.email ?
                                            <span className="error">{addEditPromoFormik.errors.email}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    disabled={isDisabled}
                                    value={addEditPromoFormik.values.email}
                                />
                            </div>
                            
                        </div>
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Password
                                    {
                                        addEditPromoFormik.touched.password && addEditPromoFormik.errors.password ?
                                            <span className="error">{addEditPromoFormik.errors.password}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="text"
                                    placeholder="Password"
                                    name="password"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    disabled={isDisabled}
                                    value={addEditPromoFormik.values.password}
                                />
                            </div>
                            
                        </div>
                        <div className='col-md-6'>
                            <div className={styles.fromGroup}>
                                <label>
                                    Role
                                    {
                                        addEditPromoFormik.touched.partnerWebsiteId && addEditPromoFormik.errors.partnerWebsiteId ?
                                            <span className="error">{addEditPromoFormik.errors.partnerWebsiteId.value}</span>
                                            :
                                            null
                                    }
                                </label>
                                <Select
                                    options={[{label:"Select Role",value:""},...partners] as any}
                                    className="text-white"
                                    styles={customStyles}
                                    placeholder="Select Role"
                                    defaultValue={{label:"Select Role",value:""}}
                                    
                                
                                    onChange={(values) => addEditPromoFormik.setFieldValue("partnerWebsiteId", values)}
                                    ref={selectInputRef}
                                    value={addEditPromoFormik.values.partnerWebsiteId}
                                    isDisabled={params.id ? true : false}
                                />
                            </div>
                        </div>
                        {/* <div className='col-md-6'>
                            <div className={styles.fromGroup}>
                                <label>
                                    Role
                                    {
                                        addEditPromoFormik.touched.permissionId && addEditPromoFormik.errors.permissionId ?
                                            <span className="error">{addEditPromoFormik.errors.permissionId.value}</span>
                                            :
                                            null
                                    }
                                </label>
                                <Select
                                    options={[{label:"Select Role",value:""},...roles] as any}
                                    className="text-white"
                                    styles={customStyles}
                                    placeholder="Select Role"
                                    defaultValue={{label:"Select Role",value:""}}
                                    
                                
                                    onChange={(values) => addEditPromoFormik.setFieldValue("permissionId", values)}
                                    ref={selectInputRef}
                                     value={addEditPromoFormik.values.permissionId}
                                    // isDisabled={params.id ? true : false}
                                />
                            </div>
                        </div> */}
                        {/* <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                   Partner
                                    {
                                        addEditPromoFormik.touched.promoCode && addEditPromoFormik.errors.promoCode ?
                                            <span className="error">{addEditPromoFormik.errors.promoCode}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="text"
                                    placeholder="Promo Code"
                                    name="promoCode"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    disabled={isDisabled}
                                    value={addEditPromoFormik.values.promoCode}
                                />
                            </div>
                        </div> */}
                    </div>
                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Discount
                                    {
                                        addEditPromoFormik.touched.discount && addEditPromoFormik.errors.discount ?
                                            <span className="error">{addEditPromoFormik.errors.discount}</span>
                                            :
                                            null
                                    }
                                </label>
                                <input
                                    className={styles.input}
                                    type="number"
                                    placeholder="Discount"
                                    name="discount"
                                    disabled={isDisabled}
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    value={addEditPromoFormik.values.discount}
                                />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className={styles.fromGroup}>
                                <label>
                                    Partner
                                    {
                                        addEditPromoFormik.touched.countries && addEditPromoFormik.errors.countries ?
                                            <span className="error">{addEditPromoFormik.errors.countries}</span>
                                            :
                                            null
                                    }
                                </label>
                                <Select
                                    options={countries as any}
                                    isMulti
                                    onChange={(values) => addEditPromoFormik.setFieldValue("countries", values)}
                                    ref={selectInputRef}
                                    value={addEditPromoFormik.values.countries}
                                    isDisabled={isDisabled}
                                />
                            </div>
                        </div>
                    </div> */}
                    {/* <div className="row">
                        <div className={parseInt(addEditPromoFormik.values.type) === 1 ? "col-md-4" : "col-md-6"}>
                            <div className={styles.fromGroup}>
                                <label>
                                    Discount Type
                                    {
                                        addEditPromoFormik.touched.type && addEditPromoFormik.errors.type ?
                                            <span className="error">{addEditPromoFormik.errors.type}</span>
                                            :
                                            null
                                    }
                                </label>
                                <select
                                    disabled={isDisabled}
                                    name="type"
                                    value={addEditPromoFormik.values.type}
                                    onChange={addEditPromoFormik.handleChange}
                                >
                                    <option value={0}>Select</option>
                                    <option value={1}>Fixed</option>
                                    <option value={2}>Percentage</option>
                                </select>
                            </div>
                        </div>
                        {
                            parseInt(addEditPromoFormik.values.type) === 1 ?
                                <div className="col-md-4">
                                    <div className={styles.fromGroup}>
                                        <label>
                                            Discount Currency
                                            {
                                                addEditPromoFormik.touched.discountCurrency && addEditPromoFormik.errors.discountCurrency ?
                                                    <span className="error">{addEditPromoFormik.errors.discountCurrency}</span>
                                                    :
                                                    null
                                            }
                                        </label>
                                        <select
                                            disabled={isDisabled}
                                            name="discountCurrency"
                                            value={addEditPromoFormik.values.discountCurrency}
                                            onChange={addEditPromoFormik.handleChange}
                                        >
                                            <option value=''>Select</option>
                                            {CurrencyCodes.codes().map((item, index) => (
                                                <option key={index} value={item}>{item}</option>
                                            ))}
                                        </select>

                                    </div>
                                </div> : null
                        }
                        <div className={parseInt(addEditPromoFormik.values.type) === 1 ? "col-md-4" : "col-md-6"}>
                            <div className={styles.fromGroup}>
                                <label>
                                    Minimum Spend Currency
                                    {
                                        addEditPromoFormik.touched.minimumSpendCurrency && addEditPromoFormik.errors.minimumSpendCurrency ?
                                            <span className="error">{addEditPromoFormik.errors.minimumSpendCurrency}</span>
                                            :
                                            null
                                    }
                                </label>
                                <select
                                    disabled={isDisabled}
                                    name="minimumSpendCurrency"
                                    value={addEditPromoFormik.values.minimumSpendCurrency}
                                    onChange={addEditPromoFormik.handleChange}
                                >
                                    <option value=''>Select</option>
                                    {CurrencyCodes.codes().map((item, index) => (
                                        <option key={index} value={item}>{item}</option>
                                    ))}
                                </select>

                            </div>
                        </div>
                    </div> */}

                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Start Date
                                    {
                                        addEditPromoFormik.touched.startDate && addEditPromoFormik.errors.startDate ?
                                            <span className="error">{addEditPromoFormik.errors.startDate}</span>
                                            :
                                            null
                                    }
                                </label>
                                <DatePicker
                                    disabled={isDisabled}
                                    name="startDate"
                                    className={styles.input}
                                    onChange={(date) => addEditPromoFormik.setFieldValue("startDate", date)}
                                    selected={new Date(addEditPromoFormik.values.startDate)}
                                    minDate={new Date()}
                                    dateFormat="dd-MMM-yyyy"
                                />

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    End Date
                                    {
                                        addEditPromoFormik.touched.endDate && addEditPromoFormik.errors.endDate ?
                                            <span className="error">{addEditPromoFormik.errors.endDate}</span>
                                            :
                                            null
                                    }
                                </label>
                                <DatePicker
                                    disabled={isDisabled}
                                    name="endDate"
                                    className={styles.input}
                                    onChange={(date) => addEditPromoFormik.setFieldValue("endDate", date)}
                                    selected={new Date(addEditPromoFormik.values.endDate)}
                                    minDate={new Date()}
                                    dateFormat="dd-MMM-yyyy"
                                />
                            </div>
                        </div>
                    </div> */}

                    {/* <div className="row">
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Frequency per user
                                    {
                                        addEditPromoFormik.touched.frequencyPerUser && addEditPromoFormik.errors.frequencyPerUser ?
                                            <span className="error">{addEditPromoFormik.errors.frequencyPerUser}</span>
                                            :
                                            null
                                    }
                                </label>
                                <p className={styles.subLabel}>How much time can a single user use this promo for?</p>
                                <input
                                    className={styles.input}
                                    disabled={isDisabled}
                                    type="number"
                                    placeholder="Frequency per user"
                                    name="frequencyPerUser"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    value={addEditPromoFormik.values.frequencyPerUser}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={styles.fromGroup}>
                                <label>
                                    Minimum Amount
                                    {
                                        addEditPromoFormik.touched.minimumSpend && addEditPromoFormik.errors.minimumSpend ?
                                            <span className="error">{addEditPromoFormik.errors.minimumSpend}</span>
                                            :
                                            null
                                    }
                                </label>
                                <p className={styles.subLabel}>Minimum amount required to avail this promo</p>
                                <input
                                    className={styles.input}
                                    disabled={isDisabled}
                                    type="number"
                                    placeholder="Amount"
                                    name="minimumSpend"
                                    onChange={addEditPromoFormik.handleChange}
                                    onBlur={addEditPromoFormik.handleBlur}
                                    value={addEditPromoFormik.values.minimumSpend}
                                />

                            </div>
                        </div>
                    </div> */}
                     <div className="col-md-12">
                        <div className={styles.fromGroup}>
                            <input type="button" disabled={isDisabled} onClick={addEditPromoFormik.submitForm} className={styles.submit} value={params.id ? "Update" : "Add"} />
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
};

export default AddNewUser;
